<template>
  <div>
    <vx-card
      id="busca-beneficiarios"
      class="mt-3 relative z-999 vs-con-loading__container"
      title="Busca de clientes"
      collapseAction
      collapsed
      subtitle="Abaixo ficam os clientes encontrados no sistema, você pode fazer uma busca e filtrar as informações que precisa."
    >
      <div class="vx-row">
        <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
          <div class="vx-row">
            <vs-col vs-w="12" class="vx-col">
              <span>Código:</span>
            </vs-col>
            <vs-col vs-w="12" class="vx-col">
              <vs-input v-uppercase type="number" @keyup.enter="buscar()" class="w-full" v-model="filtro.cod" />
            </vs-col>
          </div>
        </vs-col>

        <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
          <div class="vx-row">
            <vs-col vs-w="12" class="vx-col">
              <span>Nome do Cliente:</span>
            </vs-col>
            <vs-col vs-w="12" class="vx-col">
              <vs-input v-uppercase @keyup.enter="buscar()" class="w-full" v-model="filtro.nome" />
            </vs-col>
          </div>
        </vs-col>

        <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
          <div class="vx-row">
            <vs-col vs-w="12" class="vx-col">
              <span>CPF:</span>
            </vs-col>
            <vs-col vs-w="12" class="vx-col">
              <vs-input v-uppercase
                @keyup.enter="buscar()"
                class="w-full"
                v-model="filtro.cpf"
                v-mask="'###.###.###-##'"
              />
            </vs-col>
          </div>
        </vs-col>

        <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
          <div class="vx-row">
            <vs-col vs-w="12" class="vx-col">
              <span>Número do documento:</span>
            </vs-col>
            <vs-col vs-w="12" class="vx-col">
              <vs-input v-uppercase @keyup.enter="buscar()" class="w-full" v-model="filtro.rg" />
            </vs-col>
          </div>
        </vs-col>

        <vs-col vs-w="12" class="vx-col">
          <div class="vx-row">
            <vs-col vs-w="12" class="vx-row">
              <vs-button
                color="#5abfa3"
                type="relief"
                size="small"
                icon-pack="feather"
                icon="icon-search"
                v-on:click="buscar(filtro)"
                class="mr-3"
              >Buscar</vs-button>
              <vs-button
                v-if="possuiFiltros"
                color="#5abfa3"
                type="relief"
                size="small"
                icon-pack="feather"
                icon="icon-search"
                v-on:click="limparFiltros()"
              >Limpar Filtros</vs-button>
            </vs-col>
          </div>
        </vs-col>
      </div>
    </vx-card>
  </div>
</template>


<script>
export default {
  name: "busca-clientes",
  data() {
    return {
      filtro: {}
    };
  },
  created() {
    this.setupFiltros({ ...this.$route.query });
  },
  watch: {
    $route(to) {
      this.setupFiltros({ ...to.query });
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading({
          container: "#busca-beneficiarios",
          scale: 0.6
        });
      } else {
        this.$vs.loading.close("#busca-beneficiarios > .con-vs-loading");
      }
    }
  },
  computed: {
    loading() {
      return this.$store.getters.isBeneficiariosLoading();
    },
    possuiFiltros() {
      return Object.values(this.$route.query).length > 0;
    }
  },
  methods: {
    setupFiltros(query) {
      this.filtro = query;
    },
    buscar() {
      delete this.filtro.page;

      this.$router.push({
        name: "clientes",
        query: { ...this.filtro }
      });
    },
    limparFiltros() {
      this.$router.push({ name: "clientes" });
    }
  }
};
</script>
